import { render } from "./AdHocGamePage.vue?vue&type=template&id=583ec048&scoped=true"
import script from "./AdHocGamePage.vue?vue&type=script&lang=js"
export * from "./AdHocGamePage.vue?vue&type=script&lang=js"

import "./AdHocGamePage.vue?vue&type=style&index=0&id=583ec048&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583ec048"]])

export default __exports__